import { Injectable } from '@angular/core';
import { ParentService } from '../pages/A2-utils/ParentClass/ParentService';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { constant } from '../app.constants';
import { IStandingOrderSearchRequest } from '../core/interfaces/standing-order-search.interface';
import { IStandingOrderReviewedRequest } from '../core/interfaces/standing-order-reviewed.interface';
import { IResponseSuccess } from '../core/interfaces/response.interface';

@Injectable()
export class StandingOrderService  extends ParentService {

  constructor(private _http: Http) {
    super();
  }

  searchStandingOrders(request: IStandingOrderSearchRequest) {
    return this._http.post(
      constant.URL_CHANGE_STATUS_SO + '/Search',
      request,
      this.headerPost()
    ).map(
      res => res.json()
    );
  }

  updateReviewed(request: IStandingOrderReviewedRequest) {
    return this._http.put(
      constant.URL_CHANGE_STATUS_SO + '/Reviewed',
      request,
      this.headerPost()
    ).map(
      (response: Response) => response.json() as IResponseSuccess
    ).catch(
      (error: any) => Observable.throw(error.json())
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/standing-order.service.ts